"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmsSenderSupportedCountry = exports.isCanadaSmsSenderCountry = exports.isUsSmsSenderCountry = void 0;
const country_1 = require("../enums/country");
const isUsSmsSenderCountry = (country) => country === country_1.OrganizationCountry.UnitedStates;
exports.isUsSmsSenderCountry = isUsSmsSenderCountry;
const isCanadaSmsSenderCountry = (country) => country === country_1.OrganizationCountry.Canada;
exports.isCanadaSmsSenderCountry = isCanadaSmsSenderCountry;
const isSmsSenderSupportedCountry = (country) => (0, exports.isUsSmsSenderCountry)(country) || (0, exports.isCanadaSmsSenderCountry)(country);
exports.isSmsSenderSupportedCountry = isSmsSenderSupportedCountry;
